var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppAbsoluteMenu',_vm._g(_vm._b({attrs:{"rounded":"lg","maxWidth":_vm.MENU_MAX_WIDTH,"minWidth":_vm.MENU_MIN_WIDTH,"content-class":"absolute-data-input-menu"},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'AppAbsoluteMenu',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }